import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function afmValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let afm = control?.value;
    if (!afm || typeof afm != 'string') return null;

    if (!afm.match(/^\d{9}$/) || afm == '000000000') return { afm: true };

    let m = 1;
    let sum = 0;
    for (let i = 7; i >= 0; i--) {
      m *= 2;
      sum += +afm.charAt(i) * m;
    }
    if ((sum % 11) % 10 != +afm.charAt(8)) return { afm: true };

    return null;
  };
}
